import { useState, useEffect } from 'react';
import { MEDIA_QUERIES } from '../constants/breakpoints';

/**
 * 监听媒体查询匹配状态，支持 SSR（服务端返回 false）
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mq = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mq.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [query]);

  return matches;
}

/** 手机布局：< 768px（含 iPad 竖屏） */
export function useIsMobile(): boolean {
  return useMediaQuery(MEDIA_QUERIES.isMobile);
}

/** 平板布局：768–1023px（iPad 横屏等） */
export function useIsTablet(): boolean {
  return useMediaQuery(MEDIA_QUERIES.isTablet);
}

/** 桌面布局：≥ 1024px */
export function useIsDesktop(): boolean {
  return useMediaQuery(MEDIA_QUERIES.isDesktop);
}
